package com.eladfinish.bible.contest.screens.americanQuestions.model

data class AmericanQuestionItem(
    val num: Int,
    val question: String,
    val options: List<String>,
    val correctOption: String,
    val sourceBook: String? = null,
    val sourceChapter: String = "",
    val author: String = "",
    val isIncluded: Boolean = true,
    val userAnswer: Int = -1,  // 0->A, 1->B, 2->C, 3->D
    val correctAnswerAfterShuffle: Int = -1,
) {
    val filename: String
        get() = "$sourceBook-$sourceChapter.txt"

    val shuffledOptions: List<String>
        get() = options.shuffled()

    override fun toString(): String = buildString {
        append("$num. $question\n")
        append("א. ${options[0]}\n")
        append("ב. ${options[1]}\n")
        append("ג. ${options[2]}\n")
        append("ד. ${options[3]}\n")
        append("נכונה: $correctOption\n")
        append("מספר תשובה שנבחרה: $userAnswer\n")
        append("מספר תשובה נכונה אחרי ערבוב: $correctAnswerAfterShuffle\n")
        append("מחבר: $author\n")
        append("filename: $filename\n")
        append("isIncluded: $isIncluded\n")
    }
}
